import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Button,
  Row,
  Col,
} from "reactstrap";
import CoreEngine from "../../core/CoreEngine";
import RequestEngine from "../../core/RequestEngine";
import { connect } from "react-redux";
import loadingAction from "../../core/redux/actions/loadingAction";
import ReactTable from "react-table";
import TablePagination from "components/Table/TablePagination";
import strings from "../../core/translate";
import RowActions, {
  editAction,
  deleteAction,
} from "components/Table/RowActions";
import { Scopes } from "../../shared/scopes.enum";

class CityList extends CoreEngine {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      dataSource: [],
      globalFilter: "",
      startDateFilter: null,
      endDateFilter: null,
      canWrite: false,
    };
    this.pathname = "cities";
    this.engine = new RequestEngine();
  }

  componentDidMount() {
    const canWrite = this.hasPermission([Scopes.CITIES_WRITE])
    this.setState({canWrite})
    this.callPage();
  }

  async handleDelete(valueid) {
    if (window.confirm(strings.confirmdelete)) {
      this.props.loadingAction(true);
      const result = await this.engine.deleteItem(this.pathname, valueid);
      if (result) {
        this.handlePage();
      }
      this.props.loadingAction(false);
    }
  }

  handleEdit(index, dataid) {
    const data = this.state.dataSource[index].data;

    this.props.history.push({
      pathname: `/admin/${this.pathname}/edit/${dataid}`,
      data,
    });
  }

  handleActions(index, item) {
    return (
      <RowActions
        actions={[
          editAction(() => this.handleEdit(index, item.id), this.state.canWrite),
          deleteAction(() => this.handleDelete(item.id), this.state.canWrite),
        ]}
      />
    );
  }
  async callPage() {
    const response = await this.engine.getItem(this.pathname);

    // Check if response.data and response.data.items exist and if they are an array
    if (response && response.status === 200) {
      this.setState({
        isLoading: false,
        dataSource: response.data.items.map((item, key) => ({
          id: key,
          data: item,
          name: item.name,
          created: new Date(item.createdAt),
          actions: this.handleActions(key, item),
        })),
      });
    }

    this.props.loadingAction(false);
  }
  handlePage() {
    this.props.loadingAction(true);
    this.callPage();
  }

  handleAdd() {
    this.props.history.push(`/admin/${this.pathname}/add`);
  }

  render() {
    const { dataSource, isLoading, canWrite } = this.state;

    let columns = [
      {
        Header: strings.name,
        accessor: "name",
      },

      {
        Header: strings.created,
        accessor: "created",
        Cell: (row) => row.value.toLocaleDateString(),
      },
      {
        Header: strings.actions,
        accessor: "actions",
        sortable: false,
        filterable: false,
      },
    ];

    return (
      <>
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <CardTitle tag="h4" className="pull-left"></CardTitle>
                  {canWrite &&  (<Button
                    color="primary"
                    className="pull-right"
                    onClick={() => this.handleAdd()}
                  >
                    {strings.add}
                  </Button>)}
                </CardHeader>
                <CardBody>
                  <ReactTable
                    previousText={strings.previous}
                    nextText={strings.next}
                    loadingText={strings.loading}
                    noDataText={strings.nodata}
                    pageText={strings.page}
                    data={dataSource}
                    defaultFilterMethod={this.filterCaseInsensitive}
                    filterable
                    loading={isLoading}
                    columns={columns}
                    defaultPageSize={10}
                    showPaginationTop={false}
                    showPaginationBottom
                    PaginationComponent={TablePagination}
                    /*
                                          You can choose between primary-pagination, info-pagination, success-pagination, warning-pagination, danger-pagination or none - which will make the pagination buttons gray
                                        */
                    className="-striped -highlight primary-pagination"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadingAction: (payload) => dispatch(loadingAction(payload)),
});
export default connect(null, mapDispatchToProps)(CityList);
